import React from "react";
import { Modal } from "antd";

const FormModal = ({ title, visible, onOk, onCancel, children }) => {
  return (
    <Modal title={title} open={visible} onOk={onOk} onCancel={onCancel}>
      {children}
    </Modal>
  );
};

export default FormModal;
